import React from 'react';
import { Box, Card, CardContent, Skeleton, Stack } from '@mui/material';

export const LoadingCard = () => (
	<Box mb={1}>
		<Card>
			<CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
				<Stack spacing={0.75}>
					<Skeleton variant="text" height={24} width="80%" />
					<Skeleton variant="text" height={20} width="40%" />
					<Skeleton variant="text" height={16} width="60%" />
					<Skeleton variant="text" height={16} width="50%" />
					<Skeleton variant="text" height={20} width="30%" />
				</Stack>
			</CardContent>
		</Card>
	</Box>
);